import React from 'react';
import PropTypes from 'prop-types';

function Tile({ id, name, onTileClick, imageUrl }) {
  const hasClick = typeof onTileClick === 'function';

  return (
    <button className="tile" type="button" key={id} onClick={onTileClick} disabled={!hasClick}>
      <div className="tiles-card-name" title={name}>
        {name}
      </div>
      <div className="tiles-card-preview">
        <img className="tiles-card-image" src={imageUrl} alt={name} />
      </div>
    </button>
  );
}

Tile.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  name: PropTypes.string.isRequired,
  imageUrl: PropTypes.string,
  onTileClick: PropTypes.func,
};

export default Tile;
